<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoIpsAutorizadas()" *ngIf="tabItemSeleccionado === 'tabIpsAutorizadas' && !editarRegistroIpsAutorizadas" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabIpsAutorizadas' && editarRegistroIpsAutorizadas">
            <a type="button" class="icnTable" (click)="GuardarIpsAutorizadas()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarIpsAutorizadas()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab label="tabInformacion" class="row">
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-3 col-12" *ngIf="form.get('id').value > 0">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Activo (*)</mat-label>
                        <mat-select formControlName="activo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Login (*)</mat-label>
                        <input matInput formControlName="login" autocomplete="off">
                        <mat-error *ngIf="form.get('login').hasError('required')">El Login es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('login').hasError('maxlength')">La longitud máxima es 30</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Rol</mat-label>
                        <mat-select formControlName="idRol">
                            <mat-option [value]="item.id" *ngFor="let item of this.listaRoles">{{item.rol}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('idRol').hasError('required')">El Rol es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('idRol').hasError('min')">El Rol es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Número de identificación (*)</mat-label>
                        <input matInput formControlName="nroDocumento" autocomplete="off">
                        <mat-error *ngIf="form.get('nroDocumento').hasError('required')">El número de identificación es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nroDocumento').hasError('maxlength')">La longitud máxima es 20</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombres (*)</mat-label>
                        <input matInput formControlName="nombre" autocomplete="off">
                        <mat-error *ngIf="form.get('nombre').hasError('required')">El nombre es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nombre').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Apellidos (*)</mat-label>
                        <input matInput formControlName="apellidos" autocomplete="off">
                        <mat-error *ngIf="form.get('apellidos').hasError('required')">El Apellido es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('apellidos').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Correo electronico (*)</mat-label>
                        <input matInput formControlName="email" autocomplete="off">
                        <mat-error *ngIf="form.get('email').hasError('required')">El Correo electronico es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('email').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        <mat-error *ngIf="form.get('email').hasError('email')">El Correo electronico no tiene formato correcto</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Número movil (*)</mat-label>
                        <input matInput formControlName="movil" autocomplete="off">
                        <mat-error *ngIf="form.get('movil').hasError('required')">El Número movil es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('movil').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Provincias</mat-label>
                        <mat-select formControlName="provincia">
                            <mat-option [value]="item.codigo" *ngFor="let item of this.listaProvincias">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('provincia').hasError('required')">La Provincia es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ciudad</mat-label>
                        <mat-select formControlName="ciudad">
                            <mat-option [value]="item.codigo" *ngFor="let item of this.listaCiudadesEdicion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('ciudad').hasError('required')">La Ciudad es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Domicilio (*)</mat-label>
                        <input matInput formControlName="domicilio" autocomplete="off">
                        <mat-error *ngIf="form.get('domicilio').hasError('required')">El Domicilio es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('domicilio').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabRoles" *ngIf="form.get('mostrarRolesAliado').value">
            <ng-template mat-tab-label>
                <span>Roles</span>
            </ng-template>
            <div class="mat-elevation-z8 p-0">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSourceRolesCanal" matSort class="table table-striped table-hover">

                        <!-- aliado Column -->
                        <ng-container matColumnDef="aliado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Aliado</th>
                            <td mat-cell *matCellDef="let row"> {{row.aliado}} </td>
                        </ng-container>
                        <!-- canal Column -->
                        <ng-container matColumnDef="canal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Canal</th>
                            <td mat-cell *matCellDef="let row"> {{row.canal}} </td>
                        </ng-container>
                        <!-- rol Column -->
                        <ng-container matColumnDef="rol">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Rol</th>
                            <td mat-cell *matCellDef="let row"> {{row.rol}} </td>
                        </ng-container>
                        <!-- seleccionado Column -->
                        <ng-container matColumnDef="seleccionado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <mat-checkbox [(ngModel)]="seleccionarTodos" (ngModelChange)="SeleccionoTodos()">
                                    Asignado
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox [(ngModel)]="row.seleccionado">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnasEncabezadoRolesCanal"></tr>
                        <tr mat-row *matRowDef="let row; columns: columnasEncabezadoRolesCanal;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="fondopaginador">
                <mat-paginator #paginatorroles [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
            </div>
        </mat-tab>
        <mat-tab label="tabIpsAutorizadas">
            <ng-template mat-tab-label>
                <span>Ips autorizadas</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formIpsAutorizadas" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroIpsAutorizadas">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ip publica (*)</mat-label>
                            <input matInput formControlName="ipPublica" autocomplete="off" type="text">
                            <mat-error *ngIf="formIpsAutorizadas.get('ipPublica').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formIpsAutorizadas.get('ipPublica').hasError('maxlength')">La longitud máxima es 20</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceIpsAutorizadas" matSort class="table table-striped table-hover">
                            <ng-container matColumnDef="ip">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ip publica</th>
                                <td mat-cell *matCellDef="let row"> {{row.ipPublica}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarIpsAutorizadas(row)" *ngIf="!editarRegistroIpsAutorizadas">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarIpsAutorizadas(row)" *ngIf="!editarRegistroIpsAutorizadas">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoIpsAutorizadas"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoIpsAutorizadas;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatoripsautorizadas [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>